import { marketDynamicsTerms, searchRoutes, searchTerms } from '../../constants';
import { constant, createNavConfig, formatPeriodTitle } from '../../constants/nav';
import {
    listingsBreakdownRoute,
    officeBreakdownRoute,
    officeListingsRoute
} from '../../market-dynamics/constants/routes';
import { valueFormattersByTimePeriod } from '../../market-dynamics/constants/timePeriodMappings';

export const backNavbarTimeTitleRoutes = [officeBreakdownRoute, listingsBreakdownRoute];

export const getBackNavbarConfig = ({ route, title, backBtnTitle }) => {
    return {
        [officeBreakdownRoute]: createNavConfig(marketDynamicsTerms.marketDynamics, (context) =>
            formatPeriodTitle(context.period?.timePeriodStart, valueFormattersByTimePeriod[title])
        ),
        [listingsBreakdownRoute]: createNavConfig(marketDynamicsTerms.marketDynamics, (context) =>
            formatPeriodTitle(context.period?.timePeriodStart, valueFormattersByTimePeriod[title])
        ),
        [officeListingsRoute]: createNavConfig(searchTerms.offices, constant(title)),
        [searchRoutes.agentsGainedBreakdown]: createNavConfig(
            backBtnTitle || searchTerms.agentMovement,
            constant(title)
        ),
        [searchRoutes.officeListBreakdown]: createNavConfig(
            searchTerms.agentMovement,
            constant(title)
        )
    }[route];
};
